
import { createSafeHTML } from '@/utils/sanitize';

interface RichTextBlockProps {
  content: {
    body: string;
  };
}

export const RichTextBlock = ({ content }: RichTextBlockProps) => {
  const { body } = content;

  if (!body) return null;

  return (
    <section className="py-12 px-6">
      <div className="max-w-4xl mx-auto">
        <div 
          className="prose prose-lg max-w-none prose-headings:text-gray-900 prose-p:text-gray-700 prose-a:text-purple-600 prose-a:hover:text-purple-700 prose-img:rounded-lg prose-img:shadow-md"
          dangerouslySetInnerHTML={createSafeHTML(body)}
        />
      </div>
    </section>
  );
};
